import * as yup from 'yup';

export const initialValues = {
	postalCode: '',
	state: '',
	city: '',
	place: '',
	number: '',
	complement: '',
};

const schema = 
yup.object().shape({
	postalCode: yup.string().matches(/([0-9]{5}-[0-9]{3})/, {message:'CEP é obrigatório!', excludeEmptyString:true}).required('CEP é obrigatório!'),
	state: yup.string().required('Estado é obrigatório!'),
	city: yup.string().required('Cidade é obrigatório'),
	place: yup.string().required('Rua é obrigatório!'),
	number: yup.number().required('Número é obrigatório!'),
	complement: yup.string(),
});
export default schema;
